/**
 * @module app.MobileInteractionService
 */
import appBase from './index.js';
import {smallScreen, visibleSubMenu} from "./utils";
import {FEATURE_CHOICE_CLASS_NAME, MAIN_MENU_EVENT_NAME} from "./constants";

class MobileInteractionService {
  /**
   * @param {angular.RootScope} $rootScope Angular root scope.
   * @param {app.MapService} appMapService
   * @ngInject
   */
  constructor($rootScope, appMapService) {

    /**
     * @private
     */
    this.rootScope_ = $rootScope;

    /**
     * Use service instead of map directly since the map is not ready when this service
     * gets initialized.
     * @private
     */
    this.mapService_ = appMapService;
  }

  enableHideMenuOnMobile() {
    const map = this.mapService_.map;
    map.on('singleclick', this.hideMenuOnMobile_.bind(this));
  }

  disableHideMenuOnMobile() {
    const map = this.mapService_.map;
    map.un('singleclick', this.hideMenuOnMobile_.bind(this));
  }

  hideMenuOnMobile_(event) {
    if (smallScreen() && event.originalEvent) {
      const originalEvent = event.originalEvent;
      const isFeatureChoice = originalEvent.target.classList.contains(FEATURE_CHOICE_CLASS_NAME)
          || originalEvent.target.parentElement.classList.contains(FEATURE_CHOICE_CLASS_NAME);
      if ($('.menu').is(':visible') && !isFeatureChoice) {
        // the menu is visible
        const visibleMenuItem = visibleSubMenu();
        if (visibleMenuItem) {
          // a sub menu is visible, hide it if it's not the search
          if (!visibleMenuItem.hasClass('search')) {
            // collapse the sub menu
            this.rootScope_.$broadcast(MAIN_MENU_EVENT_NAME.COLLAPSE);
            event.stopPropagation();
          }
        } else {
          // the full menu is visible, hide it
          this.rootScope_.$broadcast(MAIN_MENU_EVENT_NAME.COLLAPSE);
          event.stopPropagation();
        }
      }
    }
  }
}

export default appBase.service('appMobileInteractionService', MobileInteractionService);
